import type { ProductAvailabilityStore } from '@micro-apps/stores';

export function isUnavailableForStay(
	productAvailabilityStore: ProductAvailabilityStore,
	productId: string
): boolean {
	const product = productAvailabilityStore.allProducts.find(item => item.id === productId);
	const hasStay = Boolean(
		productAvailabilityStore.cartStore?.bookingForProperty ||
			productAvailabilityStore.bookingsStore?.activeBooking
	);
	const hasStayDates = Boolean(
		productAvailabilityStore.dateRange?.start && productAvailabilityStore.dateRange?.end
	);

	return hasStay && hasStayDates && product?.availabilitySummary?.iconColor === 'RED';
}
